import type { NextPage } from "next";

export const Index: NextPage = () => {
  return null;
};

export default Index;
